<template>
  <form>
    <div>
      <edit-field ref="PASSWORD"
                  :editFieldInfo="passwordFieldInfo"
                  :required="true"
                  :value="password"
                  :data-table="true"
                  :password="true"
                  @error="setPasswordError"
                  @updated="setPassword">
      </edit-field>

      <edit-field ref="REPEAT_PASSWORD"
                  :editFieldInfo="repeatPasswordFieldInfo"
                  style="margin-top: 24px;"
                  :required="true"
                  :value="repeatPassword"
                  :password="true"
                  @error="setRepeatPasswordError"
                  @updated="setRepeatPassword">
      </edit-field>
    </div>
  </form>
</template>

<script lang="ts">
import { FwkButtons, FwkControls, RessourceFwkButton, RessourceFwkControl, } from '@/ressources/globalRessources';
import EditField from '@/framework/base/components/EditField.vue';
import { EditFieldType, FieldError, FieldInfo } from '@/framework/base/components/FieldInfo';
import Validator, { Rule, rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';
import { defineComponent } from "vue";

export default defineComponent({
  name: 'passwordComponent',
  components: {
    EditField,
  },
  props: {

  },
  data() {
    return {
      password: '',
      passwordError: false,
      repeatPassword: '',
      repeatPasswordError: false,
      saveLabel: RessourceFwkButton(FwkButtons.ENREGISTRER).label
    };
  },
  computed: {
    passwordFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.PASSWORD);
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = this.passwordFocusValidator;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
    repeatPasswordFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.REPEAT_PASSWORD);
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = this.repeatPasswordFocusValidator;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
  },
  methods: {
    passwordFocusValidator(value: string): Validator | null {
      return new Validator(rules.strongPassword, RULES_FRENCH_LABEL.text.strongPassword.error);
    },
    repeatPasswordFocusValidator(value: string): Validator | null {
      const rule = new Rule();
      rule.function = () => this.isSame(this.repeatPassword, this.password);
      rule.useMask = false;
      return new Validator(rule, RULES_FRENCH_LABEL.text.identique.error);
    },
    isSame(value1: string, value2: string) {
      return value1 === value2;
    },
    passwordCorrect(): boolean {
      const res = this.repeatPassword != '' &&
          this.password != '' &&
          !this.passwordError &&
          !this.repeatPasswordError &&
          this.isSame(this.repeatPassword, this.password);
      return res;
    },
    setPassword(value: string) {
      this.password = value;
      this.$emit('checkPassword',value);
    },
    setPasswordError(value: FieldError) {
      this.passwordError = value.error;
    },
    setRepeatPassword(value: string) {
      this.repeatPassword = value;
    },
    setRepeatPasswordError(value: FieldError) {
      this.repeatPasswordError = value.error;
    },
    checkFields(): boolean {
      return !(this.$refs.PASSWORD.touch() || this.$refs.REPEAT_PASSWORD.touch());
    }
  }
})

</script>

<style>
.password div.v-messages {
  display: block !important;
}
</style>
